export const getFileExtensionFromStorageUrl = function getFileExtension(
  url?: string
) {
  if (!url) {
    return ''
  }
  const parts = url.split('?')[0] // Remove the query parameters
  return parts.substring(parts.lastIndexOf('.') + 1)
}
